import { Component, OnInit, ViewChild } from '@angular/core';
import { MatLegacyTableDataSource as MatTableDataSource } from '@angular/material/legacy-table';
import { MatSort } from '@angular/material/sort';
import { MatLegacyPaginator as MatPaginator } from '@angular/material/legacy-paginator';
import { ApiResult } from 'src/app/shared/model/apiresult';
import { ICorrespondence } from '@app/modules/prospective/model/correspondence';
import { CorrespondenceService } from '../../services/correspondence.service';
import { ActivatedRoute } from '@angular/router';
import { Guid } from 'guid-typescript';
import { ExportService } from '@app/shared/services/exportservice';

@Component({
    selector: 'correspondence',
    templateUrl: './correspondence.component.html'
})
export class CorrespondenceComponent {
    studentID: Guid;
    displayedColumns: string[] = ['occurance', 'code', 'description', 'action'];
    dataSource = new MatTableDataSource<ICorrespondence>();
    @ViewChild(MatSort, { static: true }) sort: MatSort;
    @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
    constructor(
        private _correspondenceservice: CorrespondenceService,
        private _route: ActivatedRoute,
        private _exportService: ExportService
    ) {
    }

    ngOnInit() {
        this._route.queryParams.subscribe(params => {
            this.studentID = params.id;
        });
        this.getCorrespondenceById();
    }

    private getCorrespondenceById() {
        this._correspondenceservice.getCorrespondenceById(this.studentID).subscribe((result: ApiResult<ICorrespondence[]>) => {
            if (result.validationErrors == null) {
                this.dataSource = new MatTableDataSource<ICorrespondence>(result.value);
                this.dataSource.paginator = this.paginator;
                this.dataSource.sort = this.sort;
            }
        }, error => console.error(error));
    }

    download(documentStore: ICorrespondence) {
        this._correspondenceservice.downloadCorrespondence(documentStore.studentCorrespondanceId, this.studentID).subscribe(data => {
            if (documentStore.fileExtension.toLocaleLowerCase() === ".pdf") {
                this._exportService.downloadPdf(data, documentStore.fileName);
            }
            else {
                this._exportService.downloadFile(data, documentStore.fileName);
            }
        });
    }
}
